<template>
  <router-view/>
</template>

<script>
  import RouteEntryMixin from '@com/mixins/route-entry'

  export default {
    mixins: [RouteEntryMixin]
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/vue/app/limits/Limits.Entry.vue